module.exports = __webpack_public_path__ + "img/tag_coming-soon.17c5239e.png";